import { formatTime } from "@core/utils/formatTime";
import { TimeslotDateData } from "../timeslots.types";
import { DAYS_FULL } from "../timeslots.constants";

export function packTimeslotDateData(m: moment.Moment): TimeslotDateData {
  // Sunday = 0
  const dayIndex = m.day();

  const hour = m.hour();

  const minute = m.minute();

  return {
    dayIndex,
    day: DAYS_FULL[dayIndex],
    hour,
    minute,
    formattedTime: formatTime(hour, minute),
    dateString: m.toISOString(),
    fullDate: m.format("MMM D"),
    // Local date in ISO format (YYYY-MM-DD) - useful for column matching
    localDateISO: m.format("YYYY-MM-DD"),
  };
}

export default packTimeslotDateData;

